// Preserve the fetched response's filters, not mutable form values during the next request.
export function buildProductReportExport(data, exportedAt = new Date().toISOString()) {
    if (!data?.generatedAt || ![2, 3].includes(data.schemaVersion)) throw new Error('새 지표를 불러온 뒤 저장해주세요.');
    return {
        format: 'kkomok-product-analysis', formatVersion: 1, exportedAt,
        source: 'admin-product-api',
        firebase: { status: data.business?.entries?.some(e => e.metric.startsWith('firebase_')) ? 'manual_monthly_reference' : 'not_included', note: 'Firebase/GA4 자료는 같은 기간·시간대·플랫폼·버전·테스트 제외 조건으로 별도 확인하세요.' },
        report: data,
    };
}

export function downloadProductReport(data) {
    if (window.IS_NATIVE_APP || window.ReactNativeWebView) {
        throw new Error('앱에서는 보고서 파일을 다운로드할 수 없어요. 브라우저에서 관리자 화면을 열어 저장해주세요.');
    }
    const blob = new Blob([JSON.stringify(buildProductReportExport(data), null, 2)], { type: 'application/json;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `pill-report-${data.from}-${data.to}-${data.audience}.json`;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return '다운로드를 요청했어요. 브라우저의 다운로드 목록을 확인해주세요.';
}
